import { ConfirmationModal } from 'components/modals/ConfirmationModal';
import { Toaster } from 'components/notification/Toaster';
import { func_validation } from 'functions';
import React, { useState } from 'react';

export function useDeleteInvoice(props) {
    const {
        deleteInvoice_status,
        deleteInvoice_requesting,

        selectedInvoices
    } = props;
    
    const [isModalVisible_deleteInvoice, setIsModalVisible_deleteInvoice] = useState(false);

    function deleteInvoice() {

        if (func_validation.isFunction(props.setAlertMsg)) 
            props.setAlertMsg([]);
    
        if (func_validation.isArrayNotEmpty(selectedInvoices)) {
            selectedInvoices.map((invoiceDetails, idx) => { 
                let invoiceId = func_validation.getObjectPropertyValue(invoiceDetails, "Id");
    
                if (func_validation.isNumberValid(invoiceId) &&
                    func_validation.isFunction(props.deleteInvoice)) {
    
                    props.deleteInvoice(invoiceId);
                }
            });   
        }
        else {
            Toaster({
                type: "info",
                msg: "Please select at least 1 invoice.",
            });
        }
    }

    let deleteInvoiceModal = (
        <ConfirmationModal
            description={"The selected invoice(s) will be deleted."}
            cancelButtonText={"Cancel"}
            confirmButtonText={"Confirm"}
            isModalVisible={isModalVisible_deleteInvoice}
            updateParentState={setIsModalVisible_deleteInvoice}
            handleOnConfirm={deleteInvoice}
            isActionLoading={deleteInvoice_requesting}
            isConfirmSuccessful={deleteInvoice_status}
        />
    );
    
    return {
        deleteInvoiceModal,
        setIsModalVisible_deleteInvoice
    }
}